export const isAuthorized = (context: { authorized: boolean }) => context.authorized

export default { isAuthorized }
